import React from 'react';
import { Switch, Form, Alert } from 'antd';

export default (props) => {
  let { record, setRecord, name } = props;
  let languagesCms = props.languagesCms;
  return (
    <Form.Item>
      {record._id ? (
        record.sendNotification ? (
          <Alert
            type="success"
            message={languagesCms.SEND_NOTIFICATION}
            banner
          />
        ) : (
          <Alert
            type="info"
            message={languagesCms.NOT_SEND_NOTIFICATION}
            banner
          />
        )
      ) : (
        <Alert message={languagesCms.NOTIFICATION_ALERT_MESSAGE} banner />
      )}

      <Switch
        checked={record[name]}
        disabled={record._id ? true : false}
        checkedChildren={languagesCms.SEND ? languagesCms.SEND : 'SEND'}
        unCheckedChildren={languagesCms.DONTSEND}
        onChange={(v) => setRecord({ ...record, [name]: v })}
      />
    </Form.Item>
  );
};
